import { ProgressBar as LemonadeProgressBar } from '@percent/lemonade';
import { ProgressBarProps } from './ProgressBar.types';
import { Flex } from '@mantine/core';
import styles from './ProgressBar.module.scss';

export const ProgressBar = ({ progress }: ProgressBarProps) => {
  if (progress === undefined) {
    return null;
  }

  return (
    <Flex className={styles.progressBar}>
      <LemonadeProgressBar
        progressPercentage={progress}
        backgroundColorComplete="primary400"
        backgroundColorIncomplete="primary400"
        shadeColor="gray90"
        sizeVariant="x-small"
        enableAnimation
      />
    </Flex>
  );
};
